import Vue from 'vue'
import Router from 'vue-router'
// 引入NProgress样式文件
import 'nprogress/nprogress.css'
import store from '@/store'
import { routerMap } from './routerMap'
Vue.use(Router)

/** fix: 导航同一地址报错  **/
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

export const constantRoutes = [
  {
    path: '/redirect',
    component: resolve => require(['../layout/index.vue'], resolve),
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: resolve => require(['@/views/redirect/index'], resolve),
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: resolve => require(['@/views/error-page/404'], resolve),
    hidden: true
  },
  {
    path: '/jobDetail',
    name: 'jobDetail',
    component: resolve => require(['@/views/jobDetail/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/improveResume',
    name: 'improveResume',
    component: resolve => require(['@/views/improveResume/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/newTips',
    name: 'newTips',
    component: resolve => require(['@/views/improveResume/component/newTips.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/iframePage',
    name: 'IframePage',
    component: resolve => require(['@/views/home/iframePage.vue'], resolve),
    meta: { title: '预览' },
    hidden: true
  },
  {
    path: '/viewOffer',
    name: 'viewOffer',
    component: resolve => require(['@/views/setting/offerManage/viewIndex.vue'], resolve),
    meta: { title: '查看Offer' },
    hidden: true
  },
  {
    path: '/activationFailed',
    name: 'activationFailed',
    component: resolve => require(['@/views/error-page/activationFailed'], resolve),
    hidden: true
  },
  {
    path: '/activationSuccess',
    name: 'activationSuccess',
    component: resolve => require(['@/views/error-page/activationSuccess'], resolve),
    hidden: true
  },
  {
    path: '/messageHyperLink/confirmInterviewInfo',
    name: 'confirmInterviewInfo',
    component: resolve => require(['@/views/messageHyperLink/confirmInterviewInfo.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/messageHyperLink/refuseInterviewReason',
    name: 'refuseInterviewReason',
    component: resolve => require(['@/views/messageHyperLink/refuseInterviewReason.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/messageHyperLink/acceptInterviewConfirm',
    name: 'acceptInterviewConfirm',
    component: resolve => require(['@/views/messageHyperLink/acceptInterviewConfirm.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/messageHyperLink/result',
    name: 'result',
    component: resolve => require(['@/views/messageHyperLink/result.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/messageHyperLink/questionnaireSurvey',
    name: 'questionnaireSurvey',
    component: resolve => require(['@/views/messageHyperLink/questionnaireSurvey.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/401',
    name: '401',
    component: resolve => require(['@/views/error-page/401'], resolve),
    hidden: true
  },
  {
    path: '/newResumeDetail/infor',
    name: 'newResumeDetailInfor',
    component: resolve => require(['@/views/newResumeDetail/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/resumeDetailIndependentPage/infor',
    name: 'newResumeDetailInfor',
    component: resolve => require(['@/views/resumeDetailIndependentPage/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/BPM_formIframe/infor', // ?businessDataKey=
    name: 'BPM_formIframe',
    component: resolve => require(['@/views/formIframe/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/my_test',
    name: 'my_test',
    component: resolve => require(['@/views/test/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/talentMap',
    name: 'talentMap',
    component: resolve => require(['@/views/talentMap/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/log',
    name: 'log',
    component: resolve => require(['@/views/log/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/accountBan',
    name: 'accountBan',
    component: resolve => require(['@/views/accountBan/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
  {
    path: '/jobInfoFormFlow',
    name: 'jobInfoFormFlow',
    component: resolve => require(['@/views/jobInfoFormFlow/index.vue'], resolve),
    meta: { mentype: 1 },
    hidden: true
  },
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
// 重新自定义一下方法,去除动态添加路由表时候的警告
router.$addRoutes = function(params) {
  // router.matcher = new Router({ mode: 'hash' }).matcher
  router.addRoutes(params)
}
// 判断是否有权限
const routeExists = (routePath, routes) => {
  for (const route of routes) {
    if (route.path === routePath) {
      return true
    }
    if (route.children && route.children.length && routeExists(routePath, route.children)) {
      return true
    }
  }
  return false
}
// 寻找有权限的子路由
const routeSibling = (code, routes) => {
  let path = ''
  for (const route of routes) {
    if (route.parentId === code) {
      if (!path) {
        path = route.path
      }
    } else if (route.children && route.children.length) {
      if (!path) {
        path = routeSibling(code, route.children)
      }
    }
  }
  return path
}
// 优化，解决chunk failed报错
router.onError(err => {
  const pattern = /Loading chunk (\d) + failed/g
  const isChunkLoadFailed = err.message.match(pattern)
  if (isChunkLoadFailed) {
    location.reload()
  }
})
let getRouter = false // 用来获取后台拿到的路由
router.beforeEach((to, from, next) => {
  const urlParams = new URLSearchParams(window.location.href)
  const isWebsiteIframe = !(window.self === window.top) && urlParams.get('source') === 'website'
  const whiteRoutes = [
    '/jobDetail',
    '/activationFailed',
    '/activationSuccess',
    '/improveResume',
    '/viewOffer',
    '/newTips',
    '/iframePage',
    '/messageHyperLink/confirmInterviewInfo',
    '/messageHyperLink/refuseInterviewReason',
    '/messageHyperLink/acceptInterviewConfirm',
    '/messageHyperLink/questionnaireSurvey',
    '/messageHyperLink/result',
    '/jobInfoFormFlow']
  // if (to.path === '/jobDetail' || to.path === '/improveResume' || to.path === '/viewOffer' || to.path === '/newTips') {
  if (whiteRoutes.some(e => e === to.path) || (to.path === '/newResumeDetail/infor' && isWebsiteIframe) || to.path === '/resumeDetailIndependentPage/infor') {
    next()
  } else if (!getRouter) { // 不加这个判断，路由会陷入死循环
    store.dispatch('app/getProducts').then(() => {
      const products = store.state.app.permission
      const obj = products.find(item => {
        return item.productCode === 'zzp' && item.productPermission.find(info => info.isEnable)
      })
      if (obj) {
        // 具备德招聘权限
        store.dispatch('app/queryMenuList').then(() => {
          const menuList = store.state.app.menuList
          let routes = []
          // 后台拿到路由
          routes = filterAsyncRouter(menuList)
          getRouter = true
          router.$addRoutes([
            ...routes,
            { path: '*', component: resolve => require(['@/views/error-page/401'], resolve), hidden: true },
            { path: '/biDashboardPreview', component: resolve => require(['@/views/reportCenter/customClassify/biDashBoardPreview.vue'], resolve), hidden: true }
          ])
          router.options.routes = router.options.routes.concat(routes)
          next({ ...to, replace: true })
        }).catch((e) => { 
          //账号封禁，跳转到对应页面
          if (e.code === '506') { 
            getRouter = true
            next({ path: '/accountBan' })
          }
        })
      } else {
        getRouter = true
        next({ path: '/401' })
      }
    })
  } else {
    next()
  }
})
function filterAsyncRouter(routes) {
  return routes.map(item => {
    const menuList = store.state.app.menuList
    const existItem = item.redirect && routeSibling(item.code, menuList) || ''
    // console.log('item.redirect', `${item.redirect} ----> ${existItem}`)
    const redirectItem = item.redirect && routeExists(item.redirect, menuList) ? item.redirect : existItem || item.redirect
    const obj = {
      id: item.code,
      path: item.path,
      name: item.name,
      always: item.always,
      hidden: item.hidden,
      redirect: redirectItem,
      parentId: item.parentId,
      meta: {
        id: item.code,
        menuType: item.meta.menuType,
        title: item.meta.title,
        icon: item.meta.icon,
        breadcrumb: item.meta.breadcrumb === false ? item.meta.breadcrumb : true
      }
    }
    if (item.component && routerMap[item.component]) {
      obj.component = routerMap[item.component]
    }
    if (item.children && item.children.length > 0) {
      obj.children = filterAsyncRouter(item.children)
    }
    return obj
  })
}
export default router
